"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the first image of a Slate document.
 *
 * @param value The Slate document.
 */
function getFirstImage(value) {
    if (!value) {
        return null;
    }
    var document;
    var image = null;
    // Deserialize document if it's a string
    if (typeof value === 'string') {
        document = JSON.parse(value);
    }
    else {
        document = value;
    }
    document.forEach(function (block) {
        // Whilst an image has not been found
        // Loop through the document's blocks
        if (!image) {
            if (block.type === 'image-uploaded' ||
                block.type === 'image-linked' ||
                block.type === 'image') {
                image = block;
            }
        }
    });
    return image;
}
exports.default = getFirstImage;
//# sourceMappingURL=getFirstImage.js.map